var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space"},[_c('Icon',{attrs:{"type":"space"}}),_c('span',[_vm._v(_vm._s(_vm.$t('com_msg_empty')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }